module.exports = __webpack_public_path__ + "static/media/logo-white.9e8b0d0f.svg";